import React, { useEffect, useState } from 'react'
import {
  fetchCategories,
  deleteCategory,
  updateCategory,
  createCategory
} from 'helpers/backend_helper'
import { Container } from 'reactstrap'
import BreadCrumb from 'Components/Common/BreadCrumb'
import { toast } from 'react-toastify'
import CategoriesTable from './CategoriesTable'
import CategoryModal from './CategoryModal'

export interface ICategory {
  _id?: string
  name: string
  description: string
  price: number
  isActive: boolean
}

const BackgroundCategories = () => {
  document.title = 'Categories | SocialBooth - Admin Dashboard'

  const [fetching, setFetching] = useState<boolean>(false)
  const [categoryRecords, setCategoryRecords] = useState<ICategory[]>([])
  const [openCategoryPopup, setOpenCategoryPopup] = useState<boolean>(false)
  const [currentCategory, setCurrentCategory] = useState<ICategory>()
  const [editMode, setEditMode] = useState<boolean>(false)

  const fetchCategoryRecords = async () => {
    try {
      setFetching(true)
      const response = await fetchCategories()
      if (response.data.success) {
        // Parse category names (they might be array format from backend)
        const categories = response.data.data.map((cat: any) => ({
          ...cat,
          name: typeof cat.name === 'string' ? cat.name : 
                (Array.isArray(cat.name) ? cat.name[0]?.tr || 'Unknown' : 'Unknown')
        }))
        setCategoryRecords(categories)
      }
      setFetching(false)
    } catch (e: any) {
      toast.error(e.message || 'Kategoriler yüklenirken hata oluştu')
      setFetching(false)
    }
  }

  useEffect(() => {
    fetchCategoryRecords()
  }, [])

  const handleOpenDetails = (id: string) => {
    const selectedCategory = categoryRecords.find((cat) => cat._id === id)
    if (selectedCategory) {
      setCurrentCategory(selectedCategory)
      setOpenCategoryPopup(true)
    }
  }

  const handleCreateOrUpdateCategory = async (params: any) => {
    try {
      const response = editMode
        ? await updateCategory(params, params._id)
        : await createCategory(params)

      if (response.data.success) {
        if (editMode) {
          const updatedRecords = categoryRecords.map((cat: ICategory) => {
            if (cat._id === response.data.data._id) {
              return response.data.data
            }
            return cat
          })
          setCategoryRecords(updatedRecords)
        } else {
          setCategoryRecords([response.data.data, ...categoryRecords])
        }
        return 'SUCCESSFULL'
      }
      return response.data.msg || 'Hata oluştu'
    } catch (e: any) {
      toast.error(e.message || 'Kategori kaydedilirken hata oluştu')
      return 'FALSE'
    }
  }

  const handleDeleteCategory = async (id: string) => {
    try {
      const response = await deleteCategory(id)
      if (response.data.success) {
        setCategoryRecords(categoryRecords.filter((cat) => cat._id !== id))
        return 'SUCCESSFULL'
      }
      return response.data.msg || 'Hata oluştu'
    } catch (e: any) {
      toast.error(e.message || 'Kategori silinirken hata oluştu')
      return 'FALSE'
    }
  }

  return (
    <React.Fragment>
      <div className='page-content'>
        <Container fluid>
          <BreadCrumb title='Categories' pageTitle='Asset Management' />
          <CategoriesTable
            categoryRecords={categoryRecords}
            setOpenCategoryPopup={setOpenCategoryPopup}
            handleOpenDetails={handleOpenDetails}
            setEditMode={setEditMode}
            handleDeleteCategory={handleDeleteCategory}
            fetching={fetching}
          />
          <CategoryModal
            isOpen={openCategoryPopup}
            setOpenPopup={setOpenCategoryPopup}
            handleCreateOrUpdateCategory={handleCreateOrUpdateCategory}
            categoryRecord={currentCategory}
            editMode={editMode}
          />
        </Container>
      </div>
    </React.Fragment>
  )
}

export default BackgroundCategories
